import React, { useContext, useMemo } from 'react'

import {
  OptionalMiddlewareContext,
  OptionalMiddlewareRequest,
  OptionalMiddlewareResponse,
} from './OptionalMiddlewareContext'

export type OptionalMiddlewareProviderProps = {
  name: string
  request?: OptionalMiddlewareRequest
  response?: OptionalMiddlewareResponse
}
export const OptionalMiddlewareProvider = ({
  name,
  response,
  request,
  children,
}: React.PropsWithChildren<OptionalMiddlewareProviderProps>) => {
  const parentContext = useContext(OptionalMiddlewareContext)
  const value = useMemo(() => {
    return {
      ...parentContext,
      [name]: {
        request,
        response,
      },
    }
  }, [response, request, parentContext])
  return <OptionalMiddlewareContext.Provider value={value}>{children}</OptionalMiddlewareContext.Provider>
}
